export default __webpack_public_path__ + "static/media/secondStageReq.4c9fe9d3.svg";